import React, { Component } from "react";
import { Button, Row, Col, Modal } from "react-bootstrap";
import { Mic } from "react-feather";
import Url from "app/shared/constants/Url";
import axios from "axios";
import Backbutton from "app/shared/components/Backbutton";
import LoadingView from "app/shared/components/Loader/LoadingView";
import TourWF from "./TourWF";
import NmWorkflowHelpGuide from "./NmWorkflowHelpGuide";
import moduleConstant from "app/views/MIS/constants";

import ConfirmModal from "app/shared/utility/ConfirmModal";
import {
  SuccessToast,
  ErrorToast,
} from "app/shared/components/Popups/ToastMessage";
import { renderToolTip } from "app/shared/utility/formHelper";
import { withTranslation } from "react-i18next";
import { compose } from "redux";
const qs = require("qs");

const RequiredText = () => <span className="text-danger mr-1">*</span>;

class NmWorkFlow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataLoading: false,
      checked: false,
      type_of_act: 0,
      activity: 0,
      sub_activity: 0,
      hazard: 0,
      sub_hazard: 0,
      zone: 0,
      person_id: 0,
      location: 0,
      department: 0,
      contractor: 0,
      Incident_date: 1,
      Incident_time: 1,
      person: 0,
      clientEmployeeMaster: 0,
      activeUser: 0,
      cost: 0,
      medicalDocument: 0,
      employee_search: 0,
      severity: 1,
      Evidence_Limit: "",
      observation: 1,
      workFlowPopup: false,
      showConfirmPopup: false,
      divisionAndDepartment: 0,
      userData: JSON.parse(localStorage.getItem("userData")),
    };
    this._NMWorkFlowView();
    this._settingCheck2 = this._settingCheck2.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount = () => {
    this._NMWorkFlowView();
  };

  _NMWorkFlowView = async () => {
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("springToken");
    await this.setState({ dataLoading: true });

    await axios
      .get(Url.nmModule.springnmsavedformsetting, {
        headers: {
          "Content-Type": "application/json",
        },
        params: {
          auth_key: token,
          user_id: userId,
        },
      })

      .then((response) => {
        this.setState({ dataLoading: false });

        if (response.data.status == 200) {
          response.data.data.map((data) => {
            if (data.parameter === "Type Of Act") {
              this.setState({ type_of_act: data.value });
            }
            if (data.parameter === "Hazard") {
              this.setState({ hazard: data.value });
            }
            if (data.parameter === "Sub Hazard") {
              this.setState({ subHazard: data.value });
            }
            if (data.parameter === "Observation") {
              this.setState({ observation: data.value });
            }
            if (data.parameter === "Incident Date") {
              this.setState({ Incident_date: data.value });
            }
            if (data.parameter === "Incident Time") {
              this.setState({ Incident_time: data.value });
            }
            if (data.parameter === "Person") {
              this.setState({ person: data.value });
            }
            if (data.parameter === "Employee Search") {
              this.setState({ employee_search: data.value });
            }
            if (data.parameter === "Zone") {
              this.setState({ zone: data.value });
            }
            if (data.parameter === "Location") {
              this.setState({ location: data.value });
            }
            if (data.parameter === "Person Id") {
              this.setState({ person_id: data.value });
            }
            if (data.parameter === "Department") {
              this.setState({ department: data.value });
            }
            if (data.parameter === "Contractor") {
              this.setState({ contractor: data.value });
            }
            if (data.parameter === "Evidence_Limit") {
              this.setState({ Evidence_Limit: data.value });
            }
            if (data.parameter === "Severity") {
              // this.setState({ severity : data.value})
            }
            if (data.parameter === "Activity") {
              this.setState({ activity: data.value });
            }
            if (data.parameter === "Sub Activity") {
              this.setState({ subActivity: data.value });
            }
            if (data.parameter === "Division and Department") {
              this.setState({ divisionAndDepartment: data.value });
            }
            if (data.parameter === "Active User") {
              this.setState({ activeUser: data.value });
            }
            if (data.parameter === "Client Employee Master") {
              this.setState({ clientEmployeeMaster: data.value });
            }
            if (data.parameter === "Document") {
              this.setState({ medicalDocument: data.value });
            }
            if (data.parameter === "Cost") {
              this.setState({ cost: data.value });
            }
          });
        }
      })
      .catch((error) => {
        this.setState({ dataLoading: false });
      });
  };

  _NMWorkFlow = async () => {
    await this.setState({ dataLoading: true, showConfirmPopup: false });

    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("springToken");

    await axios
      .put(
        Url.nmModule.springnmworkflowformsetting,
        {
          authKey: token,
          userId: userId,
          activity: this.state.activity ? 1 : 0,
          subActivity: this.state.subActivity ? 1 : 0,
          hazard: this.state.hazard,
          subHazard: this.state.subHazard ? 1 : 0,
          zone: this.state.zone,
          location: this.state.location,
          department: this.state.department,
          contractor: this.state.contractor,
          incidentDate: this.state.Incident_date,
          incidentTime: this.state.Incident_time,
          person: this.state.person,
          employeeSearch: this.state.employee_search,
          personId: this.state.person_id,
          severity: 1,
          evidenceLimit: this.state.Evidence_Limit,
          divisionAndDepartment: this.state.divisionAndDepartment,
          clientEmployeeMaster: this.state.clientEmployeeMaster,
          activeUser: this.state.activeUser,
          document: this.state.medicalDocument,
          cost: this.state.cost,
        },
        {
          params: {
            auth_key: token,
            user_id: userId,
          },
          headers: {
            "Content-Type": "application/json",
          },
        },
      )
      .then(async (response) => {
        if (!response.data.status) {
          return <LoadingView showLoading={this.state.dataLoading} />;
        }

        await this.setState({ dataLoading: false });
        if (response.data.status == 200) {
          SuccessToast("Seting Updated Successfully");
        }
      })
      .catch(async (error) => {
        ErrorToast("Something went error");
        await this.setState({ dataLoading: false });
      });
  };

  _handleSubmitConfirmation = () => {
    this._showConfirmPopup();
  };

  WfModal = (visible) => {
    this.setState({ workFlowPopup: visible });
  };

  handleChange(checked) {
    this.setState({ checked });
  }

  _settingCheck2(param, value) {
    if (value == 1) {
      if (param == 0) {
        this.setState({ type_of_act: 1 });
      } else {
        this.setState({ type_of_act: 0 });
      }
    }
    if (value == 2) {
      if (param == 0) {
        this.setState({ hazard: 1 });
      } else {
        this.setState({ hazard: 0 });
      }
    }
    if (value == 3) {
      if (param == 0) {
        this.setState({ observation: 1 });
      } else {
        this.setState({ observation: 0 });
      }
    }
    if (value == 4) {
      if (param == 0) {
        this.setState({ Incident_date: 1 });
      } else {
        this.setState({ Incident_date: 0 });
      }
    }
    if (value == 5) {
      if (param == 0) {
        this.setState({ Incident_time: 1 });
      } else {
        this.setState({ Incident_time: 0 });
      }
    }
    if (value == 6) {
      if (param == 0) {
        this.setState({ person: 1 });
      } else {
        this.setState({ person: 0 });
      }
    }
    if (value == 7) {
      if (param == 0) {
        this.setState({ zone: 1 });
      } else {
        this.setState({ zone: 0 });
      }
    }
    if (value == 8) {
      if (param == 0) {
        this.setState({ location: 1 });
        this.setState({ zone: 1 });
      } else {
        this.setState({ location: 0 });
      }
    }
    if (value == 9) {
      if (param == 0) {
        this.setState({ department: 1, divisionAndDepartment: 0 });
      } else {
        this.setState({ department: 0, divisionAndDepartment: 1 });
      }
    }
    if (value == 10) {
      if (param == 0) {
        this.setState({ contractor: 1 });
      } else {
        this.setState({ contractor: 0 });
      }
    }
    if (value == 11) {
      if (param == 0) {
        this.setState({ person_id: 1 });
      } else {
        this.setState({ person_id: 0 });
      }
    }
    if (value == 12) {
      if (param == 0) {
        this.setState({ employee_search: 1 });
      } else {
        this.setState({ employee_search: 0 });
      }
    }
    if (value == 17) {
      if (param == 0) {
        this.setState({ divisionAndDepartment: 1, department: 0 });
      } else {
        this.setState({ divisionAndDepartment: 0, department: 1 });
      }
    }
    if (value == 18) {
      if (param == 0) {
        this.setState({ clientEmployeeMaster: 1 });
      } else {
        this.setState({ clientEmployeeMaster: 0 });
      }
    }
    if (value == 19) {
      if (param == 0) {
        this.setState({ activeUser: 1 });
      } else {
        this.setState({ activeUser: 0 });
      }
    }
    if (value == 20) {
      if (param == 0) {
        this.setState({ medicalDocument: 1 });
      } else {
        this.setState({ medicalDocument: 0 });
      }
    }
    if (value == 21) {
      if (param == 0) {
        this.setState({ cost: 1 });
      } else {
        this.setState({ cost: 0 });
      }
    }
  }

  _showConfirmPopup = async () => {
    await this.setState({ showConfirmPopup: true });
  };

  _hideConfirmPopup = async () => {
    await this.setState({ showConfirmPopup: false });
  };

  render() {
    const { t } = this.props;

    return (
      <div className="profile">
        <LoadingView showLoading={this.state.dataLoading} />
        <div className="page-full tour1">
          <div className="profile-top nm-top-head">
            <div className="d-flex-center">
              <h2>
                <Backbutton />
                NM Reporting Form Setting
              </h2>
              <TourWF />
              <NmWorkflowHelpGuide />
            </div>
            <div className="nm-right-btn">
              <Button
                variant="outline-primary"
                className="nm-back-btn"
                onClick={this._handleSubmitConfirmation}
              >
                SAVE
              </Button>
              {/* <Button variant="outline-primary" className="nm-back-btn">
                BACK TO HOME
              </Button> */}
            </div>
          </div>
          <div className="nm-content">
            <div className="nm-left-content">
              <div className="rd-box nm1">
                {/* <div className="rd-box-head"> */}
                <div className="d-flex align-items-center rd-box-head mb-0">
                  <div className="d-flex align-items-center">
                    <h3 className="mr-1" style={{ marginTop: "6px" }}>
                      Reporting Parameter
                    </h3>
                    {renderToolTip(
                      moduleConstant(t).tooltips.reportingParameter,
                      "right",
                      { width: "22px" },
                      2,
                      "Info",
                      true,
                    )}
                  </div>
                </div>

                {/* </div> */}

                <div className="rd-box-bottom">
                  <Row className="row-gap">
                    <Col sm={3}>
                      <div className="feild-group">
                        <label className="check-box">
                          Acitivity
                          <input
                            name="activity"
                            type="checkbox"
                            checked={this.state.activity}
                            disabled
                          />
                          <span className="checkmark1 disabled-step"></span>
                        </label>
                      </div>
                    </Col>
                    <Col sm={3}>
                      <div className="feild-group">
                        <label className="check-box">
                          Sub Acitivity
                          <input
                            name="type_of_act"
                            type="checkbox"
                            checked={this.state.subActivity}
                            disabled
                          />
                          <span className="checkmark1 disabled-step"></span>
                        </label>
                      </div>
                    </Col>
                    <Col sm={3}>
                      <div className="feild-group">
                        <label className="check-box">
                          Hazard
                          <input
                            name="field.mandatory"
                            type="checkbox"
                            checked={this.state.hazard}
                            disabled
                          />
                          <span className="checkmark1 disabled-step"></span>
                        </label>
                      </div>
                    </Col>
                    <Col sm={3}>
                      <div className="feild-group">
                        <label className="check-box">
                          Sub Hazard
                          <input
                            name="field.mandatory"
                            type="checkbox"
                            checked={this.state.subHazard}
                            disabled
                          />
                          <span className="checkmark1 disabled-step"></span>
                        </label>
                      </div>
                    </Col>
                    <Col sm={3}>
                      <div className="feild-group">
                        <label className="check-box">
                          Incident Date
                          <input
                            name="field.mandatory"
                            type="checkbox"
                            checked={this.state.Incident_date}
                            // onClick={() =>
                            //   this._settingCheck2(this.state.Incident_date, 4)
                            // }
                            disabled
                          />
                          <span className="checkmark1 disabled-step"></span>
                        </label>
                      </div>
                    </Col>
                    <Col sm={3}>
                      <div className="feild-group">
                        <label className="check-box">
                          Incident Time
                          <input
                            name="field.mandatory"
                            type="checkbox"
                            checked={this.state.Incident_time}
                            // onClick={() =>
                            //   this._settingCheck2(this.state.Incident_time, 5)
                            // }

                            disabled
                          />
                          <span className="checkmark1 disabled-step"></span>
                        </label>
                      </div>
                    </Col>
                    <Col sm={3}>
                      <div className="feild-group">
                        <label className="check-box">
                          Involed Person Name
                          <input
                            name="field.mandatory"
                            type="checkbox"
                            checked={this.state.person}
                            onClick={() =>
                              this._settingCheck2(this.state.person, 6)
                            }
                          />
                          <span className="checkmark1"></span>
                        </label>
                      </div>
                    </Col>
                    <Col sm={3}>
                      <div className="feild-group">
                        <label className="check-box">
                          Involed Person ID
                          <input
                            name="field.mandatory"
                            type="checkbox"
                            checked={this.state.person_id}
                            onClick={() =>
                              this._settingCheck2(this.state.person_id, 11)
                            }
                          />
                          <span className="checkmark1"></span>
                        </label>
                      </div>
                    </Col>
                    <Col sm={3}>
                      <div className="feild-group">
                        <label className="check-box">
                          Active user
                          <input
                            name="field.mandatory"
                            type="checkbox"
                            checked={this.state.activeUser}
                            onClick={() =>
                              this._settingCheck2(this.state.activeUser, 19)
                            }
                          />
                          <span className="checkmark1"></span>
                        </label>
                      </div>
                    </Col>
                    <Col sm={3}>
                      <div className="feild-group">
                        <label className="check-box">
                          Employee Master
                          <input
                            name="field.mandatory"
                            type="checkbox"
                            checked={this.state.clientEmployeeMaster}
                            onClick={() =>
                              this._settingCheck2(
                                this.state.clientEmployeeMaster,
                                18,
                              )
                            }
                          />
                          <span className="checkmark1"></span>
                        </label>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
              <div className="rd-box nm2">
                <div className="rd-box-head">
                  <h3 className="mr-2">
                    Plant / Project / Client Based Parameter
                  </h3>
                </div>
                <div className="rd-box-bottom d-flex align-items-center">
                  <div className="label pr-0" style={{ marginTop: "2px" }}>
                    Checkboxes with a grey tick are pre-configured at the Plant,
                    Project, or Client level and cannot be modified here.
                  </div>
                  {renderToolTip(
                    moduleConstant(t).tooltips.PPCBasedParameter,
                    "right",
                    { width: "22px" },
                    2,
                    "Info",
                    true,
                  )}
                </div>
                <div className="rd-box-bottom">
                  <Row className="row-gap">
                    <Col sm={3}>
                      <div className="feild-group">
                        <label className="check-box">
                          Zone
                          <input
                            name="field.mandatory"
                            type="checkbox"
                            checked={this.state.zone}
                            disabled
                            // onClick={() =>
                            //   this._settingCheck2(this.state.zone, 7)
                            // }
                          />
                          <span className="checkmark1  disabled-step"></span>
                        </label>
                      </div>
                    </Col>
                    <Col sm={3}>
                      <div className="feild-group">
                        <label className="check-box">
                          Location
                          <input
                            name="field.mandatory"
                            type="checkbox"
                            checked={this.state.location}
                            disabled

                            // onClick={() =>
                            //   this._settingCheck2(this.state.location, 8)
                            // }
                          />
                          <span className="checkmark1  disabled-step"></span>
                        </label>
                      </div>
                    </Col>
                    <Col sm={3}>
                      <div className="feild-group">
                        <label className="check-box">
                          Division and Department
                          <input
                            name="field.mandatory"
                            type="checkbox"
                            checked={this.state.userData?.div_dept == 1}
                            // disabled
                          />
                          <span className="checkmark1  disabled-step"></span>
                        </label>
                      </div>
                    </Col>
                    <Col sm={3}>
                      <div className="feild-group">
                        <label className="check-box">
                          Department
                          <input
                            name="field.mandatory"
                            type="checkbox"
                            checked={this.state.userData?.div_dept == 0}
                            // disabled
                          />
                          <span className="checkmark1  disabled-step"></span>
                        </label>
                      </div>
                    </Col>
                    <Col sm={3}>
                      <div className="feild-group">
                        <label className="check-box">
                          Contractor
                          <input
                            name="field.mandatory"
                            type="checkbox"
                            checked={this.state.contractor}
                            disabled
                            // onClick={() =>
                            //   this._settingCheck2(this.state.contractor, 10)
                            // }
                          />
                          <span className="checkmark1  disabled-step"></span>
                        </label>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
              <Row>
                <Col sm={6}>
                  <div className="rd-box">
                    <div className="rd-box-head d-flex align-items-center py-1">
                      <h3 className="mr-2" style={{ marginTop: "6px" }}>
                        System Default Parameter{" "}
                      </h3>
                      {renderToolTip(
                        moduleConstant(t).tooltips.systemdefaultParameterNM,
                        "right",
                        { width: "22px" },
                        2,
                        "Info",
                        true,
                      )}
                    </div>
                    <div className="rd-box-bottom">
                      <div className="toggle-label">
                        <div className="output-text margin-right">Activity</div>
                      </div>
                    </div>
                    <div className="rd-box-bottom">
                      <div className="toggle-label">
                        <div className="output-text margin-right">Severity</div>
                      </div>
                    </div>
                    <div className="rd-box-bottom">
                      <div className="toggle-label">
                        <div className="output-text margin-right">
                          Observation
                        </div>
                      </div>
                    </div>
                    <div className="rd-box-bottom">
                      <div className="toggle-label">
                        <div className="output-text margin-right">
                          Type of Act
                        </div>
                      </div>
                    </div>
                    <div sm={12} className="mt-4 ml-0">
                      <div className="rd-box mt-4">
                        <div className="rd-box-head  d-flex align-items-center">
                          <h3 className="mr-2" style={{ marginTop: "4px" }}>
                            {" "}
                            NM Investigation Steps{" "}
                          </h3>
                          {renderToolTip(
                            moduleConstant(t).tooltips.nmInvestigationSteps,
                            "right",
                            { width: "22px", fontSize: "12px" },
                            2,
                            "Info",
                            true,
                          )}
                        </div>
                      </div>

                      <div className="rd-box-bottom pt-0">
                        <div className="toggle-label">
                          <div className="output-text margin-right">
                            <div className="feild-group">
                              <label className="check-box">
                                Step 1
                                <input
                                  name="field.mandatory"
                                  type="checkbox"
                                  checked={true}
                                  // onClick={() =>
                                  //   this._settingCheck2(step_1_detail?.parameter_value, 11)
                                  // }
                                  disabled
                                />
                                <span className="checkmark1 disabled-step" />
                              </label>
                            </div>
                            <p> Incidenet Analysis Questions - 5Y Analysis</p>
                          </div>
                        </div>
                        <div className="rd-box-bottom">
                          <div className="toggle-label">
                            <div className="output-text margin-right">
                              <div className="feild-group">
                                <label className="check-box">
                                  Step 2
                                  <input
                                    name="field.mandatory"
                                    type="checkbox"
                                    checked={true}
                                    // onClick={() =>
                                    //   this._settingCheck2(step_1_detail?.parameter_value, 11)
                                    // }
                                    disabled
                                  />
                                  <span className="checkmark1 disabled-step" />
                                </label>
                              </div>
                              <p> Root Cause Analysis </p>
                            </div>
                          </div>
                        </div>
                        <div className="rd-box-bottom">
                          <div className="toggle-label">
                            <div className="output-text margin-right">
                              <div className="feild-group">
                                <label className="check-box">
                                  Step 3
                                  <input
                                    name="field.mandatory"
                                    type="checkbox"
                                    checked={true}
                                    // onClick={() =>
                                    //   this._settingCheck2(step_1_detail?.parameter_value, 11)
                                    // }
                                    disabled
                                  />
                                  <span className="checkmark1 disabled-step" />
                                </label>
                              </div>
                              <p>
                                {" "}
                                CAPA (Corrective Action - Preventive
                                Action){" "}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col sm={6}>
                  <div className="rd-box nm3">
                    <div className="rd-box-head  d-flex align-items-center">
                      <h3 className="mr-2" style={{ marginTop: "6px" }}>
                        Evidence{" "}
                      </h3>
                      {renderToolTip(
                        moduleConstant(t).tooltips.iraEvidenceParameter,
                        "right",
                        { width: "22px" },
                        2,
                        "Info",
                        true,
                      )}
                    </div>
                    <div className="rd-box-bottom">
                      <div className="label-input1">
                        <div className="output-text margin-top">
                          Number of evidence per report
                        </div>
                        <input
                          type="text"
                          placeholder="Evidence No."
                          className="form-control"
                          value={this.state.Evidence_Limit}
                          onChange={(e) => {
                            this.setState({ Evidence_Limit: e.target.value });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
              <div className="rd-box nm2">
                <div className="rd-box-head">
                  <h3>Upload Document</h3>
                </div>
                <div className="rd-box-bottom">
                  <div className="label">
                    Users can upload Near Miss (NM) related documents as
                    reference files.{" "}
                  </div>
                </div>
                <div className="rd-box-bottom">
                  <Row className="row-gap">
                    <Col sm={3}>
                      <div className="feild-group">
                        <label className="check-box">
                          Near Miss Document
                          <input
                            name="field.mandatory"
                            type="checkbox"
                            checked={this.state.medicalDocument}
                            // disabled
                            onClick={() =>
                              this._settingCheck2(
                                this.state.medicalDocument,
                                20,
                              )
                            }
                          />
                          <span className="checkmark1 "></span>
                        </label>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
              <div className="rd-box nm2">
                <div className="rd-box-head">
                  <h3>Near Miss Costing</h3>
                </div>
                <div className="rd-box-bottom">
                  <div className="label">
                    The investigation team can enter Near Miss (NM) related
                    costs in this section. Costing fields are configurable
                    through the Costing Module.
                  </div>
                </div>
                <div className="rd-box-bottom">
                  <Row className="row-gap">
                    <Col sm={3}>
                      <div className="feild-group">
                        <label className="check-box">
                          Cost
                          <input
                            name="field.mandatory"
                            type="checkbox"
                            checked={this.state.cost}
                            // disabled
                            onClick={() =>
                              this._settingCheck2(this.state.cost, 21)
                            }
                          />
                          <span className="checkmark1 "></span>
                        </label>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
            <div className="nm-right-content">
              <div className="rd-box nm0">
                <div className="rd-box-head rd-box-head1">
                  <h3>Preview - NM Reporting Form</h3>
                </div>
                <div className="workflow-form">
                  <div className="form-group">
                    <h6>
                      <RequiredText />
                      Observation
                    </h6>
                    <Mic className="nm-mic" />
                    <textarea
                      type="text"
                      className="form-control"
                      placeholder="Write your observation here"
                    ></textarea>
                  </div>
                  <div className="form-group">
                    <h6>Service & Project</h6>
                    <Row>
                      <Col sm={6}>
                        <div className="label">
                          <RequiredText /> Service
                        </div>
                        <select className="form-control">
                          <option>Select Service</option>
                        </select>
                      </Col>
                      <Col sm={6}>
                        <div className="label">
                          <RequiredText /> Project
                        </div>
                        <select className="form-control">
                          <option>Select Project</option>
                        </select>
                      </Col>
                    </Row>
                  </div>
                  <div>
                    <h6>About Incidence</h6>
                    <Row>
                      {this.state.type_of_act == 1 && (
                        <Col sm={6}>
                          <div className="form-group">
                            <div className="label">Type of Act</div>
                            <select className="form-control">
                              <option>Select Act</option>
                            </select>
                          </div>
                        </Col>
                      )}
                      <Col sm={6}>
                        <div className="form-group">
                          <div className="label">
                            <RequiredText /> Activity
                          </div>
                          <select className="form-control">
                            <option>Select Activity</option>
                          </select>
                        </div>
                      </Col>
                      <Col sm={6}>
                        <div className="form-group">
                          <div className="label">
                            <RequiredText /> Severity
                          </div>
                          <select className="form-control">
                            <option>Select Severity</option>
                          </select>
                        </div>
                      </Col>
                      {this.state.hazard == 1 && (
                        <Col sm={6}>
                          <div className="form-group">
                            <div className="label">Hazard</div>
                            <select className="form-control">
                              <option>Select Hazard</option>
                            </select>
                          </div>
                        </Col>
                      )}
                      {this.state.Incident_date == 1 && (
                        <Col sm={6}>
                          <div className="form-group">
                            <div className="label">Incident Date</div>
                            <select className="form-control">
                              <option>Select Date</option>
                            </select>
                          </div>
                        </Col>
                      )}
                      {this.state.Incident_time == 1 && (
                        <Col sm={6}>
                          <div className="form-group">
                            <div className="label">Incident Time</div>
                            <select className="form-control">
                              <option>Select Time</option>
                            </select>
                          </div>
                        </Col>
                      )}
                      {this.state.person == 1 && (
                        <Col sm={6}>
                          <div className="form-group">
                            <div className="label">Name of Person</div>
                            <select className="form-control">
                              <option>Select Person</option>
                            </select>
                          </div>
                        </Col>
                      )}
                      {this.state.activeUser == 1 && (
                        <Col sm={6}>
                          <div className="form-group">
                            <div className="label">Active User</div>
                            <select className="form-control">
                              <option>Select Employee</option>
                            </select>
                          </div>
                        </Col>
                      )}
                      {this.state.clientEmployeeMaster == 1 && (
                        <Col sm={6}>
                          <div className="form-group">
                            <div className="label">Employee Master</div>
                            <select className="form-control">
                              <option>Select Employee</option>
                            </select>
                          </div>
                        </Col>
                      )}
                      {this.state.person_id == 1 && (
                        <Col sm={6}>
                          <div className="form-group">
                            <div className="label  ">ID</div>
                            <input
                              type="text"
                              className="form-control font-weight-500"
                              placeholder="Enter Id "
                            />
                          </div>
                        </Col>
                      )}
                    </Row>
                  </div>
                  <div>
                    <h6>Department/Contractor/Location</h6>
                    <Row>
                      {this.state.userData?.div_dept == 1 && (
                        <Col sm={6}>
                          <div className="form-group">
                            <div className="label">Division</div>
                            <select className="form-control">
                              <option>Select Division</option>
                            </select>
                          </div>
                        </Col>
                      )}
                      <Col sm={6}>
                        <div className="form-group">
                          <div className="label">Department</div>
                          <select className="form-control">
                            <option>Select Department</option>
                          </select>
                        </div>
                      </Col>
                      {this.state.contractor == 1 && (
                        <Col sm={6}>
                          <div className="form-group">
                            <div className="label">Contractor</div>
                            <select className="form-control">
                              <option>Select Contractor</option>
                            </select>
                          </div>
                        </Col>
                      )}
                      {this.state.zone == 1 && (
                        <Col sm={6}>
                          <div className="form-group">
                            <div className="label">Zone</div>
                            <select className="form-control">
                              <option>Select Zone</option>
                            </select>
                          </div>
                        </Col>
                      )}
                      {this.state.location == 1 && (
                        <Col sm={6}>
                          <div className="form-group">
                            <div className="label">Location</div>
                            <select className="form-control">
                              <option>Select Location</option>
                            </select>
                          </div>
                        </Col>
                      )}
                    </Row>
                  </div>
                  <div>
                    <h6>Steps</h6>
                    <Row>
                      <Col sm={6}>
                        <div className="form-group">
                          <div className="label">Step 1</div>
                        </div>
                      </Col>
                      <Col sm={6}>
                        <div className="form-group">
                          <div className="label">Step 2</div>
                        </div>
                      </Col>
                      <Col sm={6}>
                        <div className="form-group">
                          <div className="label">Step 3</div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal
          centered
          show={this.state.workFlowPopup}
          className="submit-modal"
        >
          <Modal.Header
            closeButton
            onClick={() => this.WfModal(false)}
          ></Modal.Header>

          <Modal.Body>
            {/* <img className="submit-img" src={require('assets/images/delete-popup.svg')} /> */}
            <p className="submit-text">UPDATED SUSSESSFULLY</p>
            <div className="modal-footer-btn">
              <button
                type="submit"
                className="red-btn"
                onClick={() => {
                  this.WfModal(false);
                  this._NMWorkFlowView();
                }}
              >
                OK
              </button>
            </div>
          </Modal.Body>
        </Modal>
        <ConfirmModal
          showConfirmPopup={this.state.showConfirmPopup}
          _handleCancel={this._hideConfirmPopup}
          _handleConfirm={this._NMWorkFlow}
        />
      </div>
    );
  }
}

export default compose(withTranslation("util"))(NmWorkFlow);
